import { Component, EventEmitter, Inject, Input, OnInit, Output, signal, computed, effect } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { PlayerViewModel } from '../../models/player.model';

import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelectionList, MatListOption, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { DatePipe, UpperCasePipe } from '@angular/common';
import { PlayerService } from '../../services/player.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-select-single-player-dialog',
    templateUrl: './select-single-player-dialog.component.html',
    styleUrls: ['./select-single-player-dialog.component.css'],
    standalone: true,
    imports: [MatDialogTitle, MatFormField, MatInput, MatButton, CdkScrollable, MatDialogContent, MatSelectionList, MatListOption, MatListItemTitle, MatListItemLine, MatDialogActions, MatDialogClose, DatePipe, UpperCasePipe, TranslatePipe]
})
export class SelectSinglePlayerDialogComponent implements OnInit {

  @Output() dataChanged =  new EventEmitter();
  @Input() Action: string;

  // Signals for form state
  userInput = signal<string | null>(null);
  isLoading = signal(false);
  filteredPlayers = signal<PlayerViewModel[]>([]);
  positionNames =  ['','G','D','D','F','F','F'];
  selectedPlayer = signal<string | null>(null);

  constructor(
    public dialogRef: MatDialogRef<SelectSinglePlayerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _playerService: PlayerService
  ) { }

  ngOnInit() {
    // Optionally, you can set up effects here if you want to auto-search on input change
    // effect(() => {
    //   if (this.userInput()) {
    //     this.search();
    //   }
    // });
  }

  selectedPlayerId() {
    return this.selectedPlayer();
  }

  onInputChange(event: Event) {
  const input = event.target as HTMLInputElement;
  this.userInput.set(input.value);
  this.search();
}

  search() {
    const searchTerm = this.userInput() ?? "";
    
    // Only search if 3 or more characters
    if (searchTerm.length < 3) {
      this.filteredPlayers.set([]);
      this.isLoading.set(false);
      return;
    }
    
    this.isLoading.set(true);
    this._playerService.search(searchTerm).subscribe(results => {
      this.filteredPlayers.set(results as PlayerViewModel[]);
      this.isLoading.set(false);
    });
  }

  // Call this when a player is selected in the template
  onPlayerSelected(playerId: string) {
    // console.log("Selected Player: ", playerId);
    this.selectedPlayer.set(playerId);
    this.dataChanged.emit(playerId);
  }
}